import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { User, UserLastVisitedURL } from 'app/core/user/user.types';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, ReplaySubject, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
    private _httpClient = inject(HttpClient);
    private _user: ReplaySubject<User> = new ReplaySubject<User>(1);
    private _userLastVisitedUrl: BehaviorSubject<UserLastVisitedURL> = new BehaviorSubject<UserLastVisitedURL>(null);


    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for user
     *
     * @param value
     */
    set user(value: User) {
        // Store the value
        this._user.next(value);
    }

    get user$(): Observable<User> {
        return this._user.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get the current signed-in user data
     */
    get(): Observable<User> {
        return this._httpClient
            .get<User>(environment.server + 'auth/me')
            .pipe(
                tap((user) => {
                    //console.log("User service ===> return", user)
                    this._user.next(user);
                })
            );
    }

    get userLastVisitedUrl$(): Observable<UserLastVisitedURL> {
        return this._userLastVisitedUrl.asObservable();
    }


    /**
     * 
     * @param fromComparisonHome 
     * @returns 
     */
    updateActionsCountingForUser(fromComparisonHome: string): Observable<boolean> {
        return this._httpClient
            .put<boolean>(environment.server + 'api/user/incrementDownloadCounting/' + fromComparisonHome, {});
    }

    /**
     * 
     * @param url 
     * @returns 
     */
    saveUserLastVisitedURL(url: string): Observable<boolean> {
        const reqHeaders = new HttpHeaders().set('Content-Type', 'application/json');
        const body = {
            date: new Date().toISOString(),
            url: url
        }

        return this._httpClient.post<boolean>(`${environment.server}api/user/last-visited-url`, body, { headers: reqHeaders })
    }

    /**
     * 
     * @returns 
     */
    getUserLastVisitedURL(): Observable<UserLastVisitedURL> {
        return this._httpClient
            .get<UserLastVisitedURL>(environment.server + 'api/user/last-visited-url')
            .pipe(
                tap((userLastVisitedURL) => {
                    console.log("returned UserLastVisitedURL")
                    this._userLastVisitedUrl.next(userLastVisitedURL)
                })
            );
    }

}
